module.exports = __webpack_public_path__ + "img/icon-home.f4833c72.svg";